
import { Component, Vue } from "vue-property-decorator";

@Component({ name: "icon-cart-add" })
export default class IconCartAdd extends Vue {
  sData: string = require("@icon/lineicons/shopping-cart-11.svg");
}
